
<template>
    <div class="report-clock">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 70.27 82.73" style="enable-background:new 0 0 70.27 82.73;" xml:space="preserve" fill="transparent" :style="{stroke: colors.theme == 'dark' ? '#fff':'#000'}">
            <g>
                <circle class="st0" cx="33.36" cy="45.58" r="29.84"/>
                <path class="st0" d="M56.42,26.64c7.11,5.45,11.69,14.04,11.69,23.69c0,16.48-13.36,29.84-29.84,29.84
                    c-9.61,0-18.17-4.55-23.62-11.61"/>
                <polyline class="st0" points="33.36,26.96 33.36,45.58 46.48,57.27 	"/>
                <polyline class="st0" points="26.08,16.81 26.08,8.63 39.19,8.63 39.19,16.81 	"/>
                <polyline class="st0" points="7.32,30.26 1.69,24.63 11.05,15.27 16.68,20.9 	"/>
                <rect x="21.42" y="2.1" class="st0" width="22.25" height="6.53"/>
            </g>
        </svg>
    </div>
</template>

<script>

export default {
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
    }
}
</script>

<style lang="scss" scoped>
</style>